import { ActionType, createReducer } from 'typesafe-actions';
import { loyaltyMemberActivityActions } from './actions';
import { LoyaltyMemberActivityState } from './types';
import moment from 'moment/moment';
import { YEAR_MONTH_FORMAT } from '../../appConstants';

export const loyaltyMemberActivityInitialState = {
  loading: false,
  data: [],
  activityMonth: moment().format(YEAR_MONTH_FORMAT),
  error: null
};

export const loyaltyMemberActivityReducer = createReducer<
  LoyaltyMemberActivityState,
  ActionType<typeof loyaltyMemberActivityActions>
>(loyaltyMemberActivityInitialState)
  .handleAction(loyaltyMemberActivityActions.fetchLoyaltyMemberActivity.request, state => ({
    ...state,
    loading: true,
    error: null
  }))
  .handleAction(loyaltyMemberActivityActions.fetchLoyaltyMemberActivity.success, (state, { payload }) => ({
    ...state,
    loading: false,
    data: payload
  }))
  .handleAction(loyaltyMemberActivityActions.fetchLoyaltyMemberActivity.failure, (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload
  }))
  .handleAction(loyaltyMemberActivityActions.setActivityMonth, (state, { payload }) => ({
    ...state,
    activityMonth: payload
  }));
